var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-image",
    {
      staticStyle: { width: "40px", height: "40px" },
      attrs: {
        src: _vm._f("picFilter")(_vm.rowData[_vm.fieldData["fieldCode"]], {
          size: "large",
        }),
        "preview-src-list": [_vm.productImage],
      },
    },
    [
      _c("div", {
        staticClass: "image-slot",
        attrs: { slot: "error" },
        slot: "error",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }